import { render, staticRenderFns } from "./CoozzyWatcherIcon.vue?vue&type=template&id=23a45c4c&scoped=true"
import script from "./CoozzyWatcherIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyWatcherIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyWatcherIcon.vue?vue&type=style&index=0&id=23a45c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a45c4c",
  null
  
)

export default component.exports